import AdLoader from './utils/ad-loader';

const adLoader = AdLoader({
  targetingValue: 'state-of-mind'
});
adLoader.init();



// WEBPACK FOOTER //
// ./main.js